<template>
    <ModalWrapper v-model="modal" :fullscreen="isMobile" max-width="600" hide-actions>
        <template v-slot:title>
            {{ $t('account_display_settings') }}
        </template>
        <template v-slot:content>
            <div class="pb-5">
                <show-commission-and-netto-checkbox v-if="useIsShowCommissionAndNettoCheckbox" />
                <cancelled-services-checkbox v-if="useIsShowCancelledServicesCheckbox" />
                <ShowConvertPricesCheckbox />
            </div>
            <v-divider v-if="authStore.isTO1" class="pb-4" />
            <order-calculations-and-settings
                v-if="authStore.isTO1"
                :order-id="order.orderId"
                elevation="0"
                @close-modal="modal = false"
            />
        </template>
    </ModalWrapper>
</template>

<script setup lang="ts">
    import OrderCalculationsAndSettings from '~/components/account/OrderCalculationsAndSettings.vue'
    import CancelledServicesCheckbox from '~/components/account/CancelledServicesCheckbox.vue'
    import ShowCommissionAndNettoCheckbox from '~src/components/account/ShowCommissionAndNettoCheckbox.vue'
    import ShowConvertPricesCheckbox from '~/components/account/ShowConvertPricesCheckbox.vue'

    const modal = defineModel<boolean>()

    const app = useNuxtApp()

    const order = computed(() => {
        return runtimeStore.orderDetails
    })

    const isMobile = computed(() => {
        return app.$breakpoint.smAndDown
    })

    const useIsShowCancelledServicesCheckbox = computed(() => {
        return (
            order.value.services?.some(
                service =>
                    service.status.toLowerCase() === 'canceled' &&
                    service.salesTerms?.find(item => item.type === 'CLIENT').price.amount === 0
            ) || order.value.services?.some(service => service.status.toLowerCase() === 'rejected')
        )
    })

    const useIsShowCommissionAndNettoCheckbox = computed(() => {
        return authStore.isAgency || authStore.isTourOperator || authStore.isCorporate
    })
</script>
